import { useTimezone } from '@app/core/hooks/useTimezone';
import { SegmentsStream } from '@mi-front/ui';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_UI_CONFIG } from '../../consts';
import { useStreamSegmentsList } from '../../hooks/segments/useStreamSegmentsQuery';
import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';

export const AudioPreview = () => {
  const segments = useStreamSegmentsList();
  const range = useStreamUserDefinedRange();

  return (
    <PreviewWrapper>
      <SegmentsStream
        fadeSides
        compressed
        tz={useTimezone()}
        height={STREAM_UI_CONFIG.previewHeight}
        range={range}
        segments={segments}
        disableHtmlEvents
        renderSvg={() => <PreviewBrush />}
        renderHtml={() => <PreviewFocusMarkers />}
      />
    </PreviewWrapper>
  );
};
